var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4225 47.3397C27.8755 50.8868 22.1245 50.8868 18.5775 47.3397L2.66029 31.4225C-0.886764 27.8755 -0.886764 22.1245 2.66029 18.5775L18.5775 2.66029C22.1245 -0.886764 27.8755 -0.886764 31.4225 2.66029L47.3397 18.5775C50.8868 22.1245 50.8868 27.8755 47.3397 31.4225L31.4225 47.3397Z",
    fill: "url(#paint0_linear_101_365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7154 46.6326C27.5589 49.7891 22.4411 49.7891 19.2846 46.6326L3.3674 30.7154C0.210867 27.5589 0.210867 22.4411 3.3674 19.2846L19.2846 3.3674C22.4411 0.210867 27.5589 0.210867 30.7154 3.3674L46.6326 19.2846C49.7891 22.4411 49.7891 27.5589 46.6326 30.7154L30.7154 46.6326Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3843C24.8243 22.1385 25.1757 22.1385 25.3024 22.3843L26.1074 23.946C26.1398 24.0089 26.191 24.0602 26.2539 24.0926L27.8156 24.8975C28.0615 25.0242 28.0615 25.3757 27.8156 25.5024L26.2539 26.3073C26.191 26.3397 26.1398 26.391 26.1074 26.4539L25.3024 28.0156C25.1757 28.2614 24.8243 28.2614 24.6976 28.0156L23.8926 26.4539C23.8602 26.391 23.809 26.3397 23.7461 26.3073L22.1844 25.5024C21.9385 25.3757 21.9385 25.0242 22.1844 24.8975L23.7461 24.0926C23.809 24.0602 23.8602 24.0089 23.8926 23.946L24.6976 22.3843Z",
    fill: "url(#paint1_angular_101_365)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3843C24.8243 22.1385 25.1757 22.1385 25.3024 22.3843L26.1074 23.946C26.1398 24.0089 26.191 24.0602 26.2539 24.0926L27.8156 24.8975C28.0615 25.0242 28.0615 25.3757 27.8156 25.5024L26.2539 26.3073C26.191 26.3397 26.1398 26.391 26.1074 26.4539L25.3024 28.0156C25.1757 28.2614 24.8243 28.2614 24.6976 28.0156L23.8926 26.4539C23.8602 26.391 23.809 26.3397 23.7461 26.3073L22.1844 25.5024C21.9385 25.3757 21.9385 25.0242 22.1844 24.8975L23.7461 24.0926C23.809 24.0602 23.8602 24.0089 23.8926 23.946L24.6976 22.3843Z",
    fill: "url(#paint2_angular_101_365)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7469 22.1552C25.434 21.5482 24.566 21.5482 24.2531 22.1552L23.4716 23.6715L21.9553 24.4531C21.3482 24.766 21.3482 25.6339 21.9553 25.9468L23.4716 26.7284L24.2531 28.2447C24.566 28.8517 25.434 28.8517 25.7469 28.2447L26.5284 26.7284L28.0447 25.9468C28.6518 25.6339 28.6518 24.766 28.0447 24.4531L26.5284 23.6715L25.7469 22.1552Z",
    stroke: "black",
    strokeOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31543 34.0779L34.0777 5.31567L44.6842 15.9223L15.922 44.6845L5.31543 34.0779Z",
    fill: "url(#paint3_linear_101_365)",
    fillOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_365",
    x: 0,
    y: 0,
    width: 50,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117138 0 0 0 0 0.176258 0 0 0 0 0.202862 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_365",
    x1: 24.9999,
    y1: 53.7623,
    x2: 24.9999,
    y2: -3.76214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AA8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE5E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_101_365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 25.2) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_101_365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 25.2) rotate(-180) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_365",
    x1: 38.901,
    y1: 1.60372,
    x2: 0.412454,
    y2: 46.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125287,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375692,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929467,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.f68568186d12ab12637e6d4489069c81.svg";
export { ForwardRef as ReactComponent };